import { useProjectContext } from "@hooks/context/useProjectContext";
import {
  SocialCommitmentLineItem,
  TargetUnit,
  createDefaultSocialCommitmentLineItem,
} from "@interfaces/commitment";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { TargetForm } from "@stories/molecules/TargetForm/TargetForm";

interface TargetModalProps {
  open: boolean;
  loading: boolean;
  targetType: TargetUnit;
  existingSocialCommitments: SocialCommitmentLineItem[];
  createSocialCommitment: (target: SocialCommitmentLineItem) => void;
  handleClose: () => void;
}

export default function TargetModal({
  loading,
  open,
  targetType,
  existingSocialCommitments,
  createSocialCommitment,
  handleClose,
}: TargetModalProps) {
  const { selectedProject } = useProjectContext();

  const onSubmit = async (socialRequirement: SocialCommitmentLineItem) => {
    if (socialRequirement) {
      await createSocialCommitment(socialRequirement);
      handleClose();
    }
  };

  if (!selectedProject) {
    return null;
  }

  const title =
    targetType === TargetUnit.Spend
      ? "Create New Spend Target"
      : "Create New Hours Target";

  return (
    <div>
      <Dialog fullWidth={true} open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <TargetForm
            socialCommitment={createDefaultSocialCommitmentLineItem(targetType)}
            existingSocialCommitments={existingSocialCommitments}
            handleSubmit={onSubmit}
            loading={loading}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
